import {Button} from "primereact/button";
import {OverlayPanel} from "primereact/overlaypanel";
import type {RefObject} from "react";
import {useTranslation} from "react-i18next";

import {useUnloadValuation} from "../../hooks/valuationLoadHooks";

interface ResetSessionPopupProps {
    ref: RefObject<OverlayPanel | null>;
}

/**
 * Popover to reset the session.
 */
export function ResetSessionPopup({ref}: ResetSessionPopupProps) {
    const {t} = useTranslation();
    // Unload WITHOUT search parameters, because we want to completely reset the session and show a blank start page
    const unloadValuation = useUnloadValuation();

    const hidePopover = () => {
        ref.current?.hide?.();
    };

    const onResetConfirmOpenInNewTab = () => {
        hidePopover();
        window.open("/", "_blank");
    };

    const onResetConfirmAccept = () => {
        hidePopover();
        void unloadValuation("/");
    };

    return (
        <OverlayPanel id="resetConfirmPopup" ref={ref} className="p-confirm-popup p-confirm-popup-custom">
            <div className="p-confirm-popup-content">
                <span className="p-confirm-popup-icon pi pi-exclamation-triangle" />
                <span className="p-confirm-popup-message">{t("header.resetConfirm")}</span>
            </div>
            <div className="p-confirm-popup-footer">
                <Button size="small" text onClick={hidePopover} label={t("header.resetConfirmNo")} />
                <Button
                    className="p-button-secondary"
                    size="small"
                    onClick={onResetConfirmOpenInNewTab}
                    label={t("header.resetConfirmOpenInNewTab")}
                />
                <Button
                    className="p-button-danger"
                    size="small"
                    autoFocus
                    onClick={onResetConfirmAccept}
                    label={t("header.resetConfirmYes")}
                />
            </div>
        </OverlayPanel>
    );
}
